import React from "react";
import PropTypes from "prop-types";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
/*istanbul ignore next */
const SearchFilter = ({ onSearch, onFilterClick, hasActiveFilters }) => {
  return (
    <div className="search-filter-wrapper">
      <div className="search-box">
        <span className="search-icon">
          <SearchOutlinedIcon />
        </span>
        <input type="text" onChange={onSearch} />
      </div>

      <button
        className="filter-btn"
        onClick={onFilterClick}
        style={{ position: "relative" }}
      >
        <FilterAltOutlinedIcon />
        {hasActiveFilters && (
          <span
            style={{
              position: "absolute",
              top: "20px",
              right: "15px",
              width: "10px",
              height: "10px",
              backgroundColor: "#FFEB3B",
              borderRadius: "50%",
              boxShadow: "0 0 0 2px #1dcaff",
            }}
          />
        )}
      </button>
    </div>
  );
};
SearchFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onFilterClick: PropTypes.func,
  hasActiveFilters: PropTypes.bool,
};

SearchFilter.defaultProps = {
  onFilterClick: undefined,
  hasActiveFilters: false,
};

export default SearchFilter;
